export class Liability {
  sOwner: string;
  sType: number;
  sTypeDesc : string;
  sResubodinationFlag: boolean;
  sBalance: number;
  sAccountNo: string;
  sCreditorName: string;
  sMonthlyPayment: number;
  sRemainingTerm: number;
  sPayoffFlag: boolean;
  sOmitFlag: boolean;
  id : string;
}
